import React from "react";
import RecodingAndMap from "./RecodingAndMap";
import SurveyDetails from "../Pages/SurveyDetails";
import InteractiveMap from "../Pages/InteractiveMap";
import BudgetReport from "../Pages/BudgetReport";

const RightSidebar = ({
  showModal,
  setShowModal,
  showInteractiveMap,
  setShowInteractiveMap,
  showReportBtn,
  setShowReportBtn,
  selectFileBtn,
  showModalDetails,
  setShowModalDetails,
  data,
  selectedPlayActionButton,
  onProcessingComplete,
  selectMapButton,
}) => {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [internalData, setInternalData] = React.useState(null);

  // Sync external data with internal state
  React.useEffect(() => {
    if (selectedPlayActionButton) {
      setInternalData(selectedPlayActionButton);
    }
  }, [selectedPlayActionButton]);

  const handleProcessingComplete = () => {
    setIsProcessing(false);
    onProcessingComplete?.(); // Safely call the callback if it exists
  };

  const startProcessing = () => {
    setIsProcessing(true);
  };

  const completeProcessing = () => {
    handleProcessingComplete();
  };

  // Determine if we have valid data to display
  const hasValidData = Boolean(
    (showModalDetails && data) ||
      (showInteractiveMap && selectMapButton) ||
      (showReportBtn && selectFileBtn?._id) ||
      (showModal && internalData)
  );

  return (
    <>
      {(showModal ||
        showModalDetails ||
        showInteractiveMap ||
        showReportBtn) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-50">
          <div className="h-screen w-[1200px] bg-white shadow-xl flex flex-col gap-5 overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center w-full bg-[#e6f9ff] p-2">
              <h2 className="text-lg font-semibold">
                {showModalDetails
                  ? data?.roadName
                  : showInteractiveMap
                  ? "Interactive Map"
                  : showReportBtn
                  ? "Budget Report"
                  : "Recoding and Mapping"}
                {internalData
                  ? ` - ${internalData.roadName}`
                  : selectMapButton
                  ? ` - ${selectMapButton.roadName}`
                  : ""}
              </h2>
              <button
                onClick={() => {
                  setShowModal(false);
                  setShowModalDetails(false);
                  setShowInteractiveMap(false);
                  setShowReportBtn(false);
                }}
                className="text-xl bg-gray-300 px-3 font-bold text-gray-600"
              >
                X
              </button>
            </div>

            {/* Modal Content */}
            <div className="p-4 flex-1 overflow-y-auto">
              {!hasValidData ? (
                <div className="flex justify-center items-center h-full">
                  <p>Loading data...</p>
                </div>
              ) : showModalDetails ? (
                <SurveyDetails data={data} />
              ) : showInteractiveMap ? (
                <InteractiveMap data={selectMapButton} rowData={data} />
              ) : showReportBtn ? (
                <BudgetReport id={selectFileBtn._id} />
              ) : (
                <RecodingAndMap
                  key={internalData?._id}
                  data={internalData}
                  onProcessingStart={startProcessing}
                  onProcessingComplete={completeProcessing}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RightSidebar;